import { Spin } from "antd";
import { useEffect, useState } from "react";
import { useInView } from "react-intersection-observer";
import getScrollbarWidth from "utils/getScrollWidth";
import { useWindowSize } from "utils/hook";
import "./index.scss";

interface LazyLoadProps {
  boxWidth?: number;
  boxHeight?: string;
  src?: string;
  // 指定比例，自动计算宽高值，适合自适应图片
  autoRatio?: number;
  once?: boolean;
}
const LazyLoad = (props: LazyLoadProps) => {
  const { boxWidth, boxHeight, src = "", autoRatio, once = true } = props;

  const { ref, inView } = useInView({ threshold: 0 });
  const [imgSrc, setImgSrc] = useState("");
  const [width] = useState(boxWidth || "100%");
  const [height, setHeight] = useState(boxHeight || "300px");
  const [widthResize] = useWindowSize();

  useEffect(() => {
    if (autoRatio) {
      setHeight((window.innerWidth - getScrollbarWidth()) / autoRatio + "px");
    }
  }, [autoRatio, widthResize]);

  useEffect(() => {
    if (once && inView) {
      !imgSrc && setImgSrc(src);
    }

    if (!once) {
      setImgSrc(inView ? src : "");
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inView]);

  return (
    <section ref={ref} className="scroll-wrapper" style={{ width, height }}>
      <section className={`placeholder-img${inView ? " hidden" : ""}`}>
        <Spin size="large"></Spin>
      </section>

      <section className="img-wrap" style={{ minHeight: height }}>
        <img src={imgSrc} alt={src} />
      </section>
    </section>
  );
};

export default LazyLoad;
